import React, { useLayoutEffect, useState } from "react";
import {
  AXIOS_GET,
  AXIOS_POST,
  AXIOS_UPDATE,
} from "../../../../server/api/crud";
import Swal from "sweetalert2";

const GenerateButtons = ({ data, name, handleMetricChange, disabled }) => {
  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2">
      {Array.from({ length: 11 }, (_, index) => {
        const selected = data === index;
        return (
          <button
            key={index}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && handleMetricChange(index, name)}
            className={`min-h-[2.5rem] min-w-[2.25rem] rounded-lg border px-2.5 py-2 text-sm font-semibold transition sm:min-w-[2.5rem] sm:px-3 ${
              selected
                ? "border-wa-accent bg-wa-accent text-wa-onaccent shadow-sm"
                : "border-wa-border bg-wa-panel2/50 text-wa-text hover:bg-wa-hover disabled:cursor-not-allowed disabled:opacity-50"
            }`}
          >
            {index}
          </button>
        );
      })}
    </div>
  );
};

const fieldClass =
  "mt-1 block w-full rounded-xl border border-wa-border bg-wa-panel2/50 px-3 py-2.5 text-sm text-wa-text ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:outline-none focus:ring-2 focus:ring-wa-accent/35 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-wa-panel/40";

const labelClass = "block text-sm font-semibold text-wa-text";

const HongerControle = ({
  setSelected,
  setOpen,
  admin = null,
  voeding,
  userdetails,
}) => {
  const [formData, setFormData] = useState({
    honger_score: 9,
    eetlust_probleem: "",
    verlangens_frequentie: "",
    verlangens_reactie: "",
    emoties_verlangens_connectie: "",
    eetgedachten_frequentie: "",
    overeten_frequentie: "",
    reactie_op_overeten: "",
    maaltijd_overslaan: "",
    user_id: userdetails?.user_id,
    voeding_id: voeding?.id,
    admin_opm: "",
  });
  const [isSaving, setIsSaving] = useState(false);

  const handleMetricChange = (data, name) => {
    setFormData({ ...formData, [name]: data });
  };

  const disabled = admin != null;

  const getData = async () => {
    try {
      const res = await AXIOS_GET(
        `voedsel/hongerenquete/user/${userdetails?.user_id}`
      );
      if (res.status === 200 && res.data?.data?.length > 0) {
        setFormData(res.data.data[0]);
      }
    } catch (e) {
      console.error("hongerenquete fetch:", e);
    }
  };

  useLayoutEffect(() => {
    getData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleNextPage = async () => {
    if (isSaving) return;
    const id = formData?.id;
    const newObject = { ...formData };

    try {
      setIsSaving(true);
      if (admin) {
        newObject.admin_id = admin?.id;
        const reponseAdmin = await AXIOS_UPDATE(
          `voedsel/hongerenquete/admin`,
          id,
          newObject
        );
        if (reponseAdmin.status === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Uw opmerking werd geplaatst",
            showConfirmButton: false,
            timer: 2500,
          });
          setSelected(2);
        } else {
          throw new Error(`Status ${reponseAdmin.status}`);
        }
      } else {
        const respons = id
          ? await AXIOS_UPDATE(`voedsel/hongerenquete`, id, formData)
          : await AXIOS_POST(`voedsel/hongerenquete`, formData);

        if (respons.status === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Honger- en eetlustvragenlijst opgeslagen",
            showConfirmButton: false,
            timer: 2500,
          });
          setSelected(2);
          if (!id && voeding?.id) {
            try {
              await AXIOS_UPDATE(`voedsel/status`, voeding.id, { status: 2 });
            } catch (err) {
              console.error("voedsel status:", err);
            }
          }
        } else {
          throw new Error(`Status ${respons.status}`);
        }
      }
    } catch (error) {
      console.error("hongerenquete save:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Opslaan is mislukt. Probeer opnieuw.",
        showConfirmButton: true,
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handlePrevPage = () => {
    if (!isSaving) setSelected(0);
  };

  const radioWrap =
    "inline-flex items-center gap-2 rounded-lg border border-wa-border bg-wa-panel2/40 px-3 py-2 text-sm text-wa-text dark:bg-wa-panel/30";

  return (
    <div className="rounded-2xl border border-wa-border/80 bg-wa-panel/20 p-4 shadow-sm ring-1 ring-black/[0.02] dark:bg-wa-panel2/15 dark:ring-white/[0.04] sm:p-6 lg:p-8">
      <div className="rounded-xl border border-wa-border/60 bg-wa-panel2/35 px-4 py-3 text-center text-sm font-medium text-wa-text sm:text-left dark:bg-wa-panel/30">
        Stap 2 — Honger &amp; eetlust: kies per vraag wat het beste bij u past.
      </div>

      <form className="mx-0 my-6 max-w-4xl space-y-8 sm:mx-auto sm:my-8 lg:my-10">
        <div>
          <label className={labelClass}>
            1. Hoe zou jij jouw honger en eetlust scoren?
          </label>
          <div className="mt-3">
            <GenerateButtons
              data={formData?.honger_score}
              disabled={disabled}
              name="honger_score"
              handleMetricChange={handleMetricChange}
            />
          </div>
          <div className="mt-3 flex flex-col gap-1 text-xs text-wa-muted sm:flex-row sm:justify-between sm:text-sm">
            <span>Nooit honger</span>
            <span className="hidden sm:inline">Normale eetlust</span>
            <span>Altijd honger</span>
          </div>
        </div>

        <div>
          <label className={labelClass} htmlFor="eetlust_probleem">
            2. Heb jij het gevoel dat je eetlustproblemen hebt?
          </label>
          <select
            id="eetlust_probleem"
            name="eetlust_probleem"
            value={formData?.eetlust_probleem}
            disabled={disabled}
            onChange={handleChange}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="Altijd">Ja, ik kan altijd eten</option>
            <option value="Soms">Soms/met momenten</option>
            <option value="Nee">Neen</option>
          </select>
        </div>

        <div>
          <label className={labelClass} htmlFor="verlangens_frequentie">
            3. Heb je last van cravings?
          </label>
          <select
            id="verlangens_frequentie"
            name="verlangens_frequentie"
            value={formData?.verlangens_frequentie}
            onChange={handleChange}
            disabled={disabled}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="Vaak">Ja, vaak/altijd</option>
            <option value="Soms">Soms/met momenten</option>
            <option value="Zelden">Neen/zelden</option>
          </select>
        </div>

        <div>
          <label className={labelClass} htmlFor="verlangens_reactie">
            4. Wat doe je wanneer je cravings hebt?
          </label>
          <select
            id="verlangens_reactie"
            name="verlangens_reactie"
            value={formData?.verlangens_reactie}
            disabled={disabled}
            onChange={handleChange}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="LatenGaan">Ik laat me gaan</option>
            <option value="Gemengd">
              Soms laat ik me gaan, soms houd ik me in
            </option>
            <option value="Onderdrukken">Ik onderdruk het</option>
          </select>
        </div>

        <div>
          <span className={labelClass}>
            5. Ervaar je soms een connectie tussen jouw emoties en cravings?
          </span>
          <div className="mt-3 flex flex-wrap gap-3">
            <label className={radioWrap}>
              <input
                type="radio"
                name="emoties_verlangens_connectie"
                disabled={disabled}
                value="Ja"
                checked={formData?.emoties_verlangens_connectie === "Ja"}
                onChange={handleChange}
                className="h-4 w-4 border-wa-border text-wa-accent focus:ring-wa-accent"
              />
              Ja
            </label>
            <label className={radioWrap}>
              <input
                type="radio"
                name="emoties_verlangens_connectie"
                disabled={disabled}
                value="Nee"
                checked={formData?.emoties_verlangens_connectie === "Nee"}
                onChange={handleChange}
                className="h-4 w-4 border-wa-border text-wa-accent focus:ring-wa-accent"
              />
              Neen
            </label>
          </div>
        </div>

        <div>
          <label className={labelClass} htmlFor="eetgedachten_frequentie">
            6. Hoe vaak denk je aan eten/het vermijden van eten?
          </label>
          <select
            id="eetgedachten_frequentie"
            name="eetgedachten_frequentie"
            value={formData?.eetgedachten_frequentie}
            onChange={handleChange}
            disabled={disabled}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="Vaak">Vaak</option>
            <option value="Soms">Soms</option>
            <option value="Nooit">Nooit</option>
          </select>
        </div>

        <div>
          <label className={labelClass} htmlFor="overeten_frequentie">
            7. Hoe vaak eet je tot op het punt dat je helemaal vol zit?
          </label>
          <select
            id="overeten_frequentie"
            name="overeten_frequentie"
            value={formData?.overeten_frequentie}
            onChange={handleChange}
            disabled={disabled}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="Vaak">Vaak</option>
            <option value="Soms">Soms</option>
            <option value="Nooit">Nooit</option>
          </select>
        </div>

        <div>
          <label className={labelClass} htmlFor="reactie_op_overeten">
            8. Wat doe je als je je hebt overeten?
          </label>
          <textarea
            id="reactie_op_overeten"
            name="reactie_op_overeten"
            value={formData?.reactie_op_overeten}
            disabled={disabled}
            onChange={handleChange}
            rows={5}
            className={`${fieldClass} resize-y`}
            placeholder="Beschrijf uw reactie…"
          />
        </div>

        <div>
          <label className={labelClass} htmlFor="maaltijd_overslaan">
            9. Hoe vaak sla je een maaltijd over of vast je bewust?
          </label>
          <select
            id="maaltijd_overslaan"
            name="maaltijd_overslaan"
            value={formData?.maaltijd_overslaan}
            onChange={handleChange}
            disabled={disabled}
            className={fieldClass}
          >
            <option value="">Selecteer een optie</option>
            <option value="Vaak">Vaak</option>
            <option value="Soms">Soms</option>
            <option value="Nooit">Nooit</option>
          </select>
        </div>

        {admin != null && (
          <div>
            <label className={labelClass} htmlFor="admin_opm">
              Opmerking specialist
            </label>
            <textarea
              id="admin_opm"
              name="admin_opm"
              value={formData?.admin_opm}
              onChange={handleChange}
              rows={6}
              className={`${fieldClass} resize-y`}
              placeholder="Geef feedback…"
            />
          </div>
        )}
      </form>

      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <button
          type="button"
          onClick={() => setOpen(false)}
          disabled={isSaving}
          className="inline-flex w-full items-center justify-center rounded-xl border border-wa-border bg-wa-panel2/60 px-4 py-3 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover disabled:opacity-50 sm:w-auto"
        >
          Annuleren
        </button>
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={handlePrevPage}
            disabled={isSaving}
            className="inline-flex flex-1 items-center justify-center rounded-xl border border-wa-border bg-wa-panel2/40 px-4 py-3 text-sm font-semibold text-wa-text transition hover:bg-wa-hover disabled:opacity-50 sm:flex-none"
          >
            Vorige
          </button>
          <button
            type="button"
            onClick={handleNextPage}
            disabled={isSaving}
            className="inline-flex flex-1 items-center justify-center rounded-xl bg-wa-accent px-5 py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent disabled:opacity-60 sm:flex-none sm:min-w-[10rem]"
          >
            {isSaving ? "Bezig…" : "Volgende"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HongerControle;
